import React from "react";
import {
  Alert,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { DEFAULT_PATH_LOW_STOCK_QUANTITY_THRESHOLD } from "../utils/pathLowStock";
import {
  FORM_CANCEL_BUTTON_SX,
  FORM_SUBMIT_BUTTON_SX,
  STANDARD_FORM_DIALOG_ACTIONS_SX,
  STANDARD_FORM_DIALOG_PAPER_SX,
  STANDARD_FORM_DIALOG_TITLE_SX,
} from "../utils/formModalStyles";

const PathLowStockAlertDialog = ({
  open,
  onClose,
  items = [],
  quantityThreshold = DEFAULT_PATH_LOW_STOCK_QUANTITY_THRESHOLD,
  onGoToInventory,
}) => {
  const outOfStockCount = items.filter((m) => m.totalQuantity === 0).length;
  const lowStockCount = items.length - outOfStockCount;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      sx={STANDARD_FORM_DIALOG_PAPER_SX}
    >
      <DialogTitle sx={STANDARD_FORM_DIALOG_TITLE_SX}>
        Low Stock Alert
      </DialogTitle>
      <DialogContent>
        {items.length === 0 ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            No pathology items are currently low or out of stock.
          </Alert>
        ) : (
          <Alert severity="warning" sx={{ mb: 2 }}>
            {items.length} pathology item{items.length === 1 ? "" : "s"} need attention
            {outOfStockCount > 0 && lowStockCount > 0
              ? ` (${outOfStockCount} out of stock, ${lowStockCount} low stock)`
              : outOfStockCount > 0
                ? " (out of stock)"
                : ""}
            . Available quantity is at or below <strong>{quantityThreshold}</strong> units.
          </Alert>
        )}

        {items.length > 0 && (
          <TableContainer sx={{ maxHeight: 360 }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>Item Name</TableCell>
                  <TableCell align="right">Available Qty</TableCell>
                  <TableCell>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.map((item, index) => (
                  <TableRow key={`${item.bomId ?? item.name}-${index}`} hover>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>
                      <Typography variant="body2" fontWeight={600}>
                        {item.name}
                      </Typography>
                    </TableCell>
                    <TableCell align="right">
                      <Typography
                        variant="body2"
                        fontWeight={700}
                        color={item.totalQuantity === 0 ? "error.main" : "warning.main"}
                      >
                        {item.totalQuantity} units
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={item.status}
                        size="small"
                        color={item.totalQuantity === 0 ? "error" : "warning"}
                        variant="outlined"
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DialogContent>
      <DialogActions sx={STANDARD_FORM_DIALOG_ACTIONS_SX}>
        <Button onClick={onClose} variant="outlined" color="primary" sx={FORM_CANCEL_BUTTON_SX}>
          Dismiss
        </Button>
        {onGoToInventory && (
          <Button
            variant="contained"
            color="primary"
            onClick={onGoToInventory}
            sx={FORM_SUBMIT_BUTTON_SX}
          >
            Go to Pathology Inventory
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default PathLowStockAlertDialog;
